// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MuPH","type":"styles_type__2RPeL","choices":"styles_choices__3T0Je"};